import {
    CALL_API
} from 'redux-api-middleware';

//add token, json headers, stringify body to API requests
export function transformAPIActions() {
    return next => action => {

        if (action[CALL_API]) {
            let call = action[CALL_API];

            const headers = call.headers || {};

            if (Object.prototype.toString.call(call.body) === '[object FormData]') {
                // headers['Content-Type'] = 'multipart/form-data';
            } else {
                if (call.body && typeof call.body !== 'string') {
                    call.body = JSON.stringify(call.body);
                    headers['Content-Type'] = 'application/json';
                }
            }
            call.headers = headers;
            call.credentials = 'same-origin';

        }
        return next(action);
    }
}



// WEBPACK FOOTER //
// ./src/js/middleware/api.js